module.exports = __webpack_public_path__ + "img/ic_qmarker_asset_cluster.585f5873.png";